\<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>机器人配置</span>
        </div>

        <AddRobot />
        <Slot class="mtop" />
        <Steal class="mtop" />
        <Gift class="mtop" />
        <Mockery class="mtop" />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getCommonCfg, updateCommonCfg } from '@/api/config/common-cfg'
import AddRobot from '@/views/config/robot-config/components/add.vue'
import Slot from '@/views/config/robot-config/components/slot.vue'
import Steal from '@/views/config/robot-config/components/steal.vue'
import Gift from '@/views/config/robot-config/components/gift.vue'
import Mockery from '@/views/config/robot-config/components/mockery.vue'
export default {
  name: 'RobotConfig',
  components: {
    AddRobot,
    Slot,
    Steal,
    Gift,
    Mockery
  },
  data() {
    return {
      formData:
        {
          'newUserMin': 0,
          'newUserMax': 0,
          'upgradeMin': 0,
          'upgradeMax': 0,
          'maxAddFriendCount': 0,
          'addSpin': 0,
          'spins': [
            { 'min': 0, 'max': 0, 'spin': 0, 'bet': 0 }
          ],
          'giftStart': 0,
          'giftEnd': 0
        }
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    onSubmit() {
      for (const k in this.formData.spins) {
        const spin = this.formData.spins[k]
        if (spin.min > spin.max) {
          this.msgError('体力上限-等级范围最小值不能大于最大值')
          return
        }
      }

      if (this.formData.newUserMin > this.formData.newUserMax) {
        this.msgError('新手引导最小值不能大于最大值')
        return
      }

      if (this.formData.upgradeMin > this.formData.upgradeMax) {
        this.msgError('升级延时最小值不能大于最大值')
        return
      }

      if (this.formData.maxAddFriendCount <= 0) {
        this.msgError('添加好友数量不能小于0')
        return
      }

      const giftStart = this.timeToTimestamp(this.formData.giftStart)
      const giftEnd = this.timeToTimestamp(this.formData.giftEnd)
      console.log(giftStart, giftEnd)
      if (giftStart > giftEnd) {
        this.msgError('礼物互赠-开始时间不能大于结束时间')
        return
      }

      const data = JSON.stringify(this.formData)
      updateCommonCfg({ name: 'robotConfig', data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getCommonCfg({ name: 'robotConfig' }).then(res => {
        if (res.code === 200) {
          this.formData = res.data
        } else {
          this.msgError(res.msg)
        }
      })
    },
    add() {
      this.formData.props.push({ 'propsId': 3, 'skin': 0, 'num': 1 })
    },
    addSpin() {
      this.formData.spins.push({ 'min': 0, 'max': 0, 'spin': 0 })
    },
    delSpin(index) {
      this.formData.spins = this.formData.spins.filter((res, inx) => {
        return inx !== index
      })
    },
    timeToTimestamp(timeStr) {
      console.log('timeToTimestamp', timeStr)
      const [hours, minutes] = timeStr.split(':')
      const date = new Date()
      date.setHours(parseInt(hours, 10))
      date.setMinutes(parseInt(minutes, 10))
      return date.getTime()
    }
  }
}
</script>

<style scoped>
.mtop{
  margin-top: 10px;
}
</style>
